const themeModule = {
  init: function() {
    const _ = this;
    _.theme_toggle();
    _.youtube_ratio();
    _.toggle_block();
    _.hover_box_color();
    window.addEventListener("load", function (event) {
      _.popup_setting();
    });
  },
  setCookie: function(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  },
  getCookie: function(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  theme_toggle: function() {

    // 초기 설정
    const savedMode = getCookie('themeMode') || 'light';
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const currentMode = savedMode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : savedMode;
    document.documentElement.setAttribute('data-theme-mode', currentMode);

    const btns = document.querySelectorAll('.theme-toggle-btn');
    btns.forEach(btn => {

      btn.addEventListener('click', () => {

        // 애니메이션 등록
        document.body.classList.add('theme-animation');
        setTimeout(() => {
          document.body.classList.remove('theme-animation');
        }, 300);

        // 테마 변경
        const savedMode = getCookie('themeMode') || 'light';
        const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const currentMode = savedMode === 'system' ? (prefersDarkMode ? 'dark' : 'light') : savedMode;

        // 최종 테마 모드
        let newMode = currentMode === 'light' ? 'dark' : 'light';

        // 만약 아이프레임 속에 있다면 html 상태만 체크하자.
        if (window.self !== window.top) {
          const htmlTheme = document.querySelector('html')?.getAttribute('data-theme-mode') === 'light' ? 'dark' : 'light' ;
          newMode = htmlTheme; // 최종 테마모드 변경
        }

        // 쿠키 설정 함수 호출
        setCookie('themeMode', newMode, 365);
        document.documentElement.setAttribute('data-theme-mode', newMode);
        
      });

    });

    // 쿠키 값을 가져오는 함수
    function getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
          return cookie.substring(name.length + 1);
        }
      }
      return null;
    }

    // 쿠키 값을 설정하는 함수
    function setCookie(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    }

  },
  youtube_ratio: function() {

    // debounce 함수 정의
    function debounce (func, wait) {
      let timeout;
      return function(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // 객체 크기 반환
    function set_width (element) {

      let ratio = 16/9; // 기본 비율
      const brandHeight = 120; // 브랜딩 영역을 숨길 트릭
      const ratios = [
        { key: 'yt-ratio-4-3', value: 16/9 },
        { key: 'yt-ratio-1-1', value: 1/1 },
        { key: 'yt-ratio-21-9', value: 21/9 },
        { key: 'yt-ratio-9-16', value: 9/16 },
        { key: 'yt-ratio-3-2', value: 3/2 },
      ];

      const container = element.closest('.hellopanda-blocks-youtube');
      ratios.forEach(item => {
        if (container.classList.contains(item.key)) {
          ratio = item.value;
        }
      });
      const minwidth = (container.offsetHeight + brandHeight) * ratio;
      element.style.minWidth = `${minwidth}px`;

    }

    const youtubes = document.querySelectorAll('.hellopanda-blocks-youtube.yt-mobile-expand .hellopanda-blocks-youtube-player');
    youtubes.forEach(element => {

      set_width(element);

      const handleDebouncedResize = debounce(() => {
        set_width(element);
      }, 300); // 500ms 이후에 실행

      // 리사이즈 이벤트 리스너 추가
      window.addEventListener('resize', () => {
        handleDebouncedResize();
      });

    });

  },
  toggle_block: function() {

    function close_all_toggle () {
      const opened_containers = document.querySelectorAll('.wp-block-hellopanda-toggle-block.toggle-active');
      opened_containers.forEach(opended_container => {
        opended_container.classList.remove('toggle-active');  
      });
    }

    addEventListener("click", (event) => {});
    onclick = (event) => {
      const container = event.target.closest('.wp-block-hellopanda-toggle-block.toggle-action-click');
      if (container && !container.classList.contains('toggle-active')) {
        container.classList.add('toggle-active');
      } else if (container && container.classList.contains('toggle-active')) {
        const container_closebtn = event.target.closest('.hellopanda-toggle-block-overlay-close');
        if (container_closebtn) {
          container.classList.remove('toggle-active');  
        }
        console.log(event.target.closest('.hellopanda-toggle-block-overlay-close'))
      } else if (!container) {
        close_all_toggle();
      }
    };

    document.addEventListener("keydown", (e) => {
      close_all_toggle();
    });

  },
  hover_box_color: function() {

    const boxContainers = document.querySelectorAll('.box-color-effect');

    boxContainers.forEach(box => {
      box.addEventListener("mouseenter", function () {

        // 현재 스타일을 dataset에 저장
        box.dataset.originalColor = box.style.color || '';
        box.dataset.originalBgColor = box.style.backgroundColor || '';
        box.dataset.originalBorderColor = box.style.borderColor || '';
        box.dataset.originalBorderTopColor = box.style.borderTopColor || '';
        box.dataset.originalBorderRightColor = box.style.borderRightColor || '';
        box.dataset.originalBorderBottomColor = box.style.borderBottomColor || '';
        box.dataset.originalBorderLeftColor = box.style.borderLeftColor || '';

        // 새로운 스타일을 적용, !important 추가
        if (box.dataset.boxHovertext) {
          box.style.setProperty('color', box.dataset.boxHovertext, 'important');
        }
        if (box.dataset.boxHoverbg) {
          box.style.setProperty('background-color', box.dataset.boxHoverbg, 'important');
        }
        if (box.dataset.boxHoverborder) {
          box.style.setProperty('border-color', box.dataset.boxHoverborder, 'important');
        }
      });
  
      box.addEventListener("mouseleave", function () {

        // 원래 스타일을 복원
        box.style.setProperty('color', box.dataset.originalColor || '');
        box.style.setProperty('background-color', box.dataset.originalBgColor || '');
        box.style.setProperty('border-color', box.dataset.originalBorderColor || '');
        box.style.setProperty('border-top-color', box.dataset.originalBorderTopColor || '');
        box.style.setProperty('border-right-color', box.dataset.originalBorderRightColor || '');
        box.style.setProperty('border-bottom-color', box.dataset.originalBorderBottomColor || '');
        box.style.setProperty('border-left-color', box.dataset.originalBorderLeftColor || '');
      });
    });

  },
  popup_setting: function() {
    
    const _ = this;

    function closePopup(popupElement) {
      const dateValue = popupElement.dataset.date;
      const key = 'hellopanda-popup-' + popupElement.dataset.key +'-'+ popupElement.dataset.code;
  
      let days = 0; // 기본값은 반복
      if (dateValue === '1day') {
          days = 1;
      } else if (dateValue === '3day') {
          days = 3;
      } else if (dateValue === '1week') {
          days = 7;
      } else if (dateValue === 'forever') {
          days = 365 * 10; // 영구적으로 닫기 위해 10년 설정
      }
  
      _.setCookie(key, 'closed', days); // 팝업 상태를 쿠키에 저장
      popupElement.style.display = 'none'; // 팝업 숨기기
    }

    // 페이지 로드 시, 쿠키 상태에 따라 팝업 보이기/숨기기 설정
    const popups = document.querySelectorAll('.wp-block-hellopanda-popup-block');
    popups.forEach(popup => {
      const key = popup.dataset.key;
      const code = popup.dataset.code;
      const cookie = _.getCookie('hellopanda-popup-' + key +'-'+ code);

      /**
       * 닫았거나, 비활성화 상태라면 아예 제거 한다. ( dom 아끼기 )
       */
      if (cookie === 'closed' || !popup.classList.contains('hellopanda-blocks-popup-active')) {
        // popup.style.display = 'none'; // 쿠키가 설정된 팝업은 숨기기
        // setTimeout(() => {
          popup.remove();
        // }, 3000);
      } else {
        popup.setAttribute('status', 'ready');
        popup.querySelector('.hellopanda-popup-block-controls').addEventListener('click', function() {
            closePopup(popup);
        });
      }
    });

    // esc, 외부 클릭시 모든 팝업창을 닫음
    if (popups.length) {
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          popups.forEach(popup => {
            console.log('제거함')
            popup.remove();
          });
        }
      });
      document.addEventListener('click', function (event) {
        if (!event.target.closest('.wp-block-hellopanda-popup-block')) {
          const current_popup = document.querySelector('.wp-block-hellopanda-popup-block');
          if (current_popup) {
            current_popup.remove();
          }
        }
      });
    }

  }
};
themeModule.init();